import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public;
  const apiKey = config.FIREBASE_API_KEY ?? "";
  const recaptchaKey = config.FIREBASE_RECAPTCHA_KEY ?? "";

  if (apiKey !== "" && recaptchaKey !== "") {
    const firebaseConfig = {
      apiKey,
      projectId: config.FIREBASE_PROJECT_ID ?? "",
      appId: config.FIREBASE_APP_ID ?? "",
    };

    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);

    // Initialize App Check
    initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(recaptchaKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
});
